import React from 'react';
import NewLinesheet from 'components/Linesheets/NewLinesheet';

const NewLinesheetsPage = () => {
  return <NewLinesheet />;
};

export default NewLinesheetsPage;
